<template>
  <div>
    <div :id="chartName"
         style="width: 100%; background-color: #FFFFFF;"
         :style="'height: ' + height"></div>
  </div>
</template>
<script>
  import moment from 'moment'
  import _ from 'lodash'

  require('amcharts3')
  require('amcharts3/amcharts/serial')
  require('amcharts3/amcharts/themes/light')
  require('amcharts3/amcharts/lang/fr')
  export default {
    name: 'SalesCharts',
    props: {
      entities: {
        type: Array,
        required: true
      },
      entityKey: {
        type: String,
        required: true
      },
      dateParam: {
        type: String,
        default: 'date'
      },
      chartType: {
        type: String,
        default: 'line'
      },
      chartName: {
        type: String,
        default: 'chart'
      },
      height: {
        type: String,
        default: '500px'
      },
      customName: {
        type: Function,
        default (val) {
          return val.name
        }
      },
      period: {
        type: Array,
        default () {
          return []
        }
      },
      teamCount: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        line: {
          type: 'line',
          fillColors: '#FFFFFF',
          bullet: 'round'
        },
        column: {
          type: 'column',
          fillAlphas: 0.9,
          lineAlpha: 0.2
        }
      }
    },
    watch: {
      entities (v) {
        if (v) {
          this.dirtyInit()
        }
      }
    },
    methods: {
      dirtyInit () {
        let data = this.processData(this.entities)
        this.makeChart(this.chartName, data)
      },
      processData (entities) {
        let data = {
          dataProvider: [],
          graphs: []
        }

        let keys = entities.map(x => {
          return x.name
        })

        let addEntry = function (date) {
          let entry = {date}
          keys.forEach(k => {
            entry[k] = 0
          })
          return entry
        }

        let scale = 'YYYY-MM'
        let tmpData = {}
        let graphKeys = {}

        entities.forEach(entity => {
          if (entity.data) {
            let entityData = entity.data[this.entityKey] || []
            let name = entity.name
            let entityPk = entity.pk

            if ((entityPk in graphKeys) === false) {
              graphKeys[entityPk] = {
                pk: entityPk,
                name,
                _color: entity._color
              }
            }
            entityData.forEach(x => {
              let date = moment(x[this.dateParam])
              date = date.format(scale)

              if (!(date in tmpData)) {
                tmpData[date] = addEntry(date)
              }
              tmpData[date][name] += 1
            })
          }
        })
        let emptyDates = _.difference(this.period, Object.keys(tmpData))
        emptyDates.forEach(date => {
          tmpData[date] = addEntry(date)
        })

        tmpData = Object.values(tmpData)
        tmpData.sort(function (a, b) {
          return new Date(a.date) - new Date(b.date)
        })
        if (this.teamCount > 0) {
          tmpData.forEach(x => {
            x['Moyenne du groupe'] = x['Moyenne du groupe'] / this.teamCount
          })
        }

        Object.values(graphKeys).forEach(e => {
          let graph = Object.assign({
            balloonText: '[[title]] : [[value]]',
            bullet: 'round',
            bulletBorderAlpha: 1,
            bulletColor: '#FFFFFF',
            id: e.name,
            lineThickness: 2,
            title: e.name,
            valueField: e.name
          }, this[this.chartType])

          if (e.name.includes('Moyenne')) {
            Object.assign(graph, {
              columnWidth: 0,
              fontSize: 8,
              fillAlphas: 1,
              fillColors: '#FFD668',
              lineColor: '#FFD668',
              type: 'smoothedLine',
              bulletBorderColor: '#FFD668'
            })
          } else {
            Object.assign(graph, {
              fillAlphas: 0,
              lineAlpha: 1,
              fillColors: '#301B7D',
              lineColor: '#231558',
              type: 'smoothedLine',
              bulletBorderColor: '#231558'
            })
          }
          data.graphs.push(graph)
        })

        data.dataProvider = !_.isEmpty(graphKeys) ? tmpData : []
        return data
      },
      makeChart (container, data) {
        const chart = window.AmCharts.makeChart(container,
          {
            type: 'serial',
            language: 'fr',
            categoryField: 'date',
            color: '#CCC',
            fontFamily: 'Roboto',
            fontSize: 10,
            categoryAxis: {
              gridPosition: 'start',
              axisColor: '#CCC',
              gridColor: '#CCC'
            },
            balloon: {
              borderAlpha: 0.12,
              borderThickness: 1,
              shadowAlpha: 0
            },
            trendLines: [],
            graphs: data.graphs.slice(),
            guides: [],
            valueAxes: [
              {
                id: 'ValueAxis-1',
                axisColor: '#CCC',
                gridColor: '#E8E8E8',
                gridAlpha: 1,
                title: '',
                integersOnly: true
              }
            ],
            chartCursor: {
              enabled: true,
              animationDuration: 0.30,
              cursorAlpha: 0.50,
              cursorColor: '#000'
            },
            allLabels: [],
            legend: {
              enabled: true,
              marginRight: 0,
              markerLabelGap: 6,
              spacing: 0,
              useGraphSettings: true
            },
            titles: [
              {
                id: 'Title-1',
                size: 15,
                color: '#0e152c',
                text: ''
              }
            ],
            dataProvider: data.dataProvider.slice()
          }
        )
        window.AmCharts.checkEmptyData = function (chart) {
          if (chart.dataProvider.length === 0) {
            chart.valueAxes[0].minimum = 0
            chart.valueAxes[0].maximum = 100
            var dataPoint = {
              dummyValue: 0
            }
            dataPoint[chart.categoryField] = ''
            chart.dataProvider = [dataPoint]
            chart.addLabel(
              0,
              '50%',
              'Aucune activité n\'a été trouvée pour la période sélectionnée.\n Essayer de sélectionner une autre période. ',
              'center',
              '14',
              'black'
            )
            chart.chartDiv.style.opacity = 1
            chart.validateNow()
          }
        }
        window.AmCharts.checkEmptyData(chart)
      }
    },
    mounted () {
      this.dirtyInit()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/UserVuePanel/Charts/SalesChart.vue